(function () {
    var PERMISSION_GRANTED = 'granted';

    angular.module('tradersyard').factory('NativeNotificationService', nativeNotificationServiceFactory);

    nativeNotificationServiceFactory.$inject = ['$q', 'NativeNotificationParamsService'];

    function nativeNotificationServiceFactory($q, NativeNotificationParamsService) {
        return {
            showNotification: showNotification,
            hasFactory: NativeNotificationParamsService.hasFactory,
        };

        /**
         * Process our Notification and show a Native one to the user.
         * Will also ask for permissions to do so.
         *
         * @param {NativeNotificationParams} notificationParams
         * @returns {Promise<Notification>}
         */
        function showNotification(notificationParams) {
            return assertShowPermission()
                .then(function () {
                    return createNativeNotification(notificationParams);
                })
                .catch(function () {
                    console.info('Permissions for native notifications not granted');
                });
        }

        /**
         * Create a Native Notification
         * @param {NativeNotificationParams} notificationParams
         * @returns {Notification}
         */
        function createNativeNotification(notificationParams) {
            var notification = new Notification(notificationParams.title, notificationParams.options);

            // assign event callbacks

            ['click'].forEach(function (event) {
                var handler = notificationParams.events && notificationParams.events[event];

                if (!handler) {
                    return;
                }

                notification.addEventListener(event, handler, {
                    once: true, // this fixes repeated event execution in chrome
                });
            });

            return notification;
        }

        /**
         * Checks if we have permission to show native notification.
         *
         * IMPORTANT: Firefox requires an access request that comes from a short lived event,
         *            therefore, we ask for permission on a first user click on the page.
         *
         * @returns {Promise<string>|$q} Resolves when permission granted. Rejects when not.
         */
        function assertShowPermission() {
            // When TY is embedded inside AgenaTrader, the Notification API is not available.
            // The error breaks the whole page :)
            if (typeof Notification === 'undefined') {
                return $q.reject('denied');
            }

            // Early return if we already have permissions to show the notification.
            if (Notification.permission === PERMISSION_GRANTED) {
                return $q.resolve(PERMISSION_GRANTED);
            }

            // `requestPermission` will reject on initial deny by user,
            // but subsequent calls successfully resolve with "denied" value
            return Notification.requestPermission().then(function (access) {
                return access === PERMISSION_GRANTED ? $q.resolve(access) : $q.reject(access);
            });
        }
    }
})();
